/**
 * Логика поведения формы для блока "Вопрос специалистам".
 * @see /public/wp-content/themes/pravmir-v4/templates/hh-get-question.mustache
 */

$(document).ready(() => {
    console.log('hh get question ready');

    // Открытие формы
    $('.hh-get-question_button').on('click', function(event) {
        event.preventDefault();

        const blockHeight = $('.hh-get-question_answer').height(); // Запоминаем высоту блока, чтобы она не прыгала

        $('.hh-get-question_question-form').css('height', blockHeight);

        $('.hh-get-question_answer').hide();
        $('.hh-get-question_question-form').show();
    });

    // Возврат к ответам
    $('.hh-get-question_form-back').on('click', function(event) {
        event.preventDefault();

        $('.hh-get-question_question-form').css('height', '');

        $('.hh-get-question_answer').show();
        $('.hh-get-question_question-form').hide();
    });
});